import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayNum, propArrayShape, propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import MyFavoriteBoardTabClipContent from './MyFavoriteBoardTabClipContent';
import MyFavoriteBoardTabContent from './MyFavoriteBoardTabContent';
const MyFavoriteBoardTab = (props) => {
    const { boardClipChecks, checks, isBoardClipsDeleting, isDeleting, isHasMore, isLoading, isShow, lists, onChangeCheck, onClickBoard, onClickCopy, onClickDelete, onClickDeleteBoardClips, onClickMore, onClickReset, showBoard, } = props;
    return (_jsx("div", Object.assign({ className: isShow ? '' : 'is-dnone' }, { children: showBoard ? (_jsx(MyFavoriteBoardTabClipContent, { checks: boardClipChecks, isDeleting: isBoardClipsDeleting, onChangeCheck: onChangeCheck, onClickCopy: onClickCopy, onClickDelete: onClickDeleteBoardClips, onClickReset: onClickReset, showBoard: showBoard })) : (_jsx(MyFavoriteBoardTabContent, { checks: checks, isDeleting: isDeleting, isHasMore: isHasMore, isLoading: isLoading, lists: lists, onChangeCheck: onChangeCheck, onClickBoard: onClickBoard, onClickCopy: onClickCopy, onClickDelete: onClickDelete, onClickMore: onClickMore })) })));
};
MyFavoriteBoardTab.propTypes = {
    boardClipChecks: propArrayNum().isRequired,
    checks: propArrayNum().isRequired,
    isBoardClipsDeleting: propBool().isRequired,
    isDeleting: propBool().isRequired,
    isHasMore: propBool().isRequired,
    isLoading: propBool().isRequired,
    isShow: propBool().isRequired,
    lists: propArrayShape().isRequired,
    onChangeCheck: propFunc().isRequired,
    onClickBoard: propFunc().isRequired,
    onClickCopy: propFunc().isRequired,
    onClickDelete: propFunc().isRequired,
    onClickDeleteBoardClips: propFunc().isRequired,
    onClickMore: propFunc().isRequired,
    onClickReset: propFunc().isRequired,
    showBoard: propShape(),
};
MyFavoriteBoardTab.defaultProps = {
    showBoard: null,
};
export default MyFavoriteBoardTab;
